import { WorkshopAppointmentType } from '@carvia/ros-client-types';

export const workshopAppointmentTypeOrder: WorkshopAppointmentType[] = [
  WorkshopAppointmentType.INSPECTION,
  WorkshopAppointmentType.OTHER_MAINTENANCE,
  WorkshopAppointmentType.RECALL_OR_WARRANTY,
  WorkshopAppointmentType.TUV,
  WorkshopAppointmentType.BRAKES_RENEWAL,
  WorkshopAppointmentType.TYRE_CHANGE_WINTER_SUMMER_FIRST_EQUIPMENT,
  WorkshopAppointmentType.TYRE_CHANGE_WEAR,
  WorkshopAppointmentType.TYRE_CHANGE,
  WorkshopAppointmentType.WINDSHIELD,
  WorkshopAppointmentType.RIM_REPAIR,
  WorkshopAppointmentType.BODY_REPAIR,
  WorkshopAppointmentType.DETAILING_FOR_RETURN,
  WorkshopAppointmentType.OTHER,
];
